import { render, staticRenderFns } from "./3_giftCard.vue?vue&type=template&id=fbea02e4&scoped=true&"
import script from "./3_giftCard.vue?vue&type=script&lang=js&"
export * from "./3_giftCard.vue?vue&type=script&lang=js&"
import style0 from "./3_giftCard.vue?vue&type=style&index=0&id=fbea02e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbea02e4",
  null
  
)

export default component.exports